window.VCA = window.VCA || {};

window.VCA.AccountDatalayer = (function ($) {

    //Login - Fail
    function dataLayerLoginFailure() {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event:'clickevent',
            category:'myvca account access',
            action:'login authentication',
            label:'fail'
        });
    }

    function dataLayerActivateAcctSuccess() {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event:'clickevent',
            category:'myvca account access',
            action:'activate account',
            label:'success'
        });
    }

    function dataLayerCreateGuestAcctSuccess() {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event:'clickevent',
            category:'myvca account access',
            action:'activate guest account',
            label:'success'
        });
    }

    function dataLayerForgotPasswordSuccess() {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event:'clickevent',
            category:'myvca account access',
            action:'forgot password',
            label:'success'
        });
    }

    function dataLayerResetPasswordSuccess() {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event:'clickevent',
            category:'myvca account access',
            action:'reset password',
            label:'success'
        });
    }

    return {
        dataLayerLoginFailure: dataLayerLoginFailure,
        dataLayerActivateAcctSuccess: dataLayerActivateAcctSuccess,
        dataLayerCreateGuestAcctSuccess: dataLayerCreateGuestAcctSuccess,
        dataLayerForgotPasswordSuccess: dataLayerForgotPasswordSuccess,
        dataLayerResetPasswordSuccess: dataLayerResetPasswordSuccess
    };



})(jQuery);